import { Card, Col, Container, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import './Contacts.css'


const Contacts = () => {
    return(
        <Container className='contacts'>
            <Card>
                <Row className='justify-content-center'>
                    <Col md={6} lg={5} xl={4}>
                        <a href='tel:91 881 26 25' >
                            <FontAwesomeIcon icon={faPhone} />
                            <p>91 881 26 25</p>
                        </a>
                    </Col>
                    <Col md={6} lg={5} xl={4}>
                        <a href='mailto:info@tefric.com'>
                            <FontAwesomeIcon icon={faEnvelope} />
                            <p>info@tefric.com</p>
                        </a>
                    </Col>
                </Row>
            </Card>
        </Container>
    )
}

export default Contacts